import React, { Component } from 'react';

import CertifedPanelLink from "./dashboard/CertifiedPanelLink";
import OverduePanelLink from "./dashboard/OverduePanelLink";
import UncertifiedPanelLink from "./dashboard/UncertifiedPanelLink";

import PanelInfo from "../widgets/PanelInfo";
import LockedAccountHyperList from "./dashboard/LockedAccountHyperlist";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faHandshake } from '@fortawesome/free-regular-svg-icons'
import { faUserTie, faBusinessTime } from '@fortawesome/free-solid-svg-icons'

function getPanelLinks(appStore) {
    return (
        <React.Fragment>
            <div className="col-sm-6 col-md-4">
                <UncertifiedPanelLink store={appStore} />
            </div>
            <div className="col-sm-6 col-md-4">
                <CertifedPanelLink store={appStore} />
            </div>
            <div className="col-sm-6 col-md-4">
                <OverduePanelLink store={appStore}  />
            </div>
        </React.Fragment>
    )
}

function getInfoBlocks(appStore) {
    const studentNumber = appStore.students.collection.length;
    const timesheetNumber = appStore.timesheets.collection.length;
    const employerNumber = appStore.employers.collection.length;
    const accountNumber = appStore.accounts.collection.length;

    return (
        <div className="row">
            <div className="col-6">
                <PanelInfo>
                    <div className="left">
                        <FontAwesomeIcon icon={faUserTie} size="2x"/>
                    </div>
                    <div className="right">
                        <span className="panelInfoLarge">{studentNumber}</span>
                        <span>Students</span>
                    </div>
                </PanelInfo>
            </div>
            <div className="col-6">
                <PanelInfo>
                    <div className="left">
                        <FontAwesomeIcon icon={faBusinessTime} size="2x"/>
                    </div>
                    <div className="right">
                        <span className="panelInfoLarge">{timesheetNumber}</span>
                        <span>Timesheets</span>
                    </div>
                </PanelInfo>           
            </div>
            <div className="col-6">
                <PanelInfo>
                    <div className="left">
                        <FontAwesomeIcon icon={faBuilding} size="2x"/>
                    </div>
                    <div className="right">
                        <span className="panelInfoLarge">{employerNumber}</span>
                        <span>Employers</span>
                    </div>
                </PanelInfo>
            </div>
            <div className="col-6">
                <PanelInfo>
                    <div className="left">
                        <FontAwesomeIcon icon={faHandshake} size="2x"/>
                    </div>
                    <div className="right">
                        <span className="panelInfoLarge">{accountNumber}</span>
                        <span>Accounts</span>
                    </div>
                </PanelInfo>
            </div>
        </div>    
    )
}


let StaffHome = function (props) {
    props.store.updateBanner(`Welcome, ${props.store.user.studentName}!`)
    
    return (
        <div>
            <div className="row">
                    {getPanelLinks(props.store)}
            </div>
            <div className="row mt-4">
                <div className="col-md-8 col-12">
                    {getInfoBlocks(props.store)}
                </div>
                <div className="col-md-4 col-12">
                    <LockedAccountHyperList 
                        store={props.store} 
                        redirectPath="/staff/accountStatus/"
                    />
                </div>
            </div>
        </div>
    );
}


export { StaffHome }
